export default {"src":"/_next/static/media/turkey.a1793c9c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};